const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M18.469 6.914a.75.75 0 0 1 .117 1.055l-7.766 9.707a1.05 1.05 0 0 1-1.64 0l-3.766-4.707a.75.75 0 1 1 1.172-.937L10 16.299l7.414-9.267a.75.75 0 0 1 1.054-.118" clip-rule="evenodd"/></svg>';
export {
  e as w
};
